import {getOfferTypeNamePlural} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";

/**
 * Generates dynamic headline for vendor detail page based on filters
 * - No filters: "{vendorName}"
 * - Location only: "{vendorName} {regionName} - inwestycje w sprzedaży"
 * - Type only: "{vendorName} {mieszkania/domy/lokale użytkowe} w sprzedaży"
 * - Location + Type: "{vendorName} {regionName} - {typ} w sprzedaży"
 */
export const generateVendorHeadline = (vendorName: string, regionName: string | null | undefined, offerType: OfferType | null | undefined): string => {
    const typeText = offerType ? getOfferTypeNamePlural(offerType) : null;

    if (regionName && typeText) {
        return `${vendorName} ${regionName} - ${typeText} w sprzedaży`;
    }

    if (regionName) {
        return `${vendorName} ${regionName} - inwestycje w sprzedaży`;
    }

    if (typeText) {
        return `${vendorName} ${typeText} w sprzedaży`;
    }

    return vendorName;
};
import {getOfferTypeNamePlural} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";

/**
 * Generates dynamic headline for vendor detail page based on filters
 * - No filters: "{vendorName}"
 * - Location only: "{vendorName} {regionName} - inwestycje w sprzedaży"
 * - Type only: "{vendorName} {mieszkania/domy/lokale użytkowe} w sprzedaży"
 * - Location + Type: "{vendorName} {regionName} - {typ} w sprzedaży"
 */
export const generateVendorHeadline = (vendorName: string, regionName: string | null | undefined, offerType: OfferType | null | undefined): string => {
    const typeText = offerType ? getOfferTypeNamePlural(offerType) : null;

    if (regionName && typeText) {
        return `${vendorName} ${regionName} - ${typeText} w sprzedaży`;
    }

    if (regionName) {
        return `${vendorName} ${regionName} - inwestycje w sprzedaży`;
    }

    if (typeText) {
        return `${vendorName} ${typeText} w sprzedaży`;
    }

    return vendorName;
};
